import { render } from "./AppCreatePaletteTemplateModal.vue?vue&type=template&id=3d3a0e59&scoped=true&ts=true"
import script from "./AppCreatePaletteTemplateModal.vue?vue&type=script&lang=ts"
export * from "./AppCreatePaletteTemplateModal.vue?vue&type=script&lang=ts"

import "./AppCreatePaletteTemplateModal.vue?vue&type=style&index=0&id=3d3a0e59&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3a0e59"]])

export default __exports__